import React, {Suspense, useEffect} from 'react';

import appActions from 'client/AppActions';
import {callAction} from 'client/framework';
import LoadingIndicator from 'generic/LoadingIndicator.react';

import {Sidemenu} from '../Sidemenu/Sidemenu';

const footerActions = appActions as Record<'SET_FOOTER_DISPLAY', symbol>;

interface Props {
  children: React.ReactNode;
  /** Page header above the scrollable content (class banner / All Classwork header). */
  header?: React.ReactNode;
  pathname: string;
}

/**
 * Shared v2 dashboard chrome: persistent sidemenu + optional page header. The content pane has its
 * own Suspense boundary so a lazy tab loads only the pane — the sidemenu and header stay put.
 */
export const TeacherDashboardLayout = ({children, header, pathname}: Props) => {
  useEffect(() => {
    callAction(footerActions.SET_FOOTER_DISPLAY, false);

    return () => {
      callAction(footerActions.SET_FOOTER_DISPLAY, true);
    };
  }, []);

  return (
    <div className='-mt-[60px] flex h-[calc(100vh-60px)] background-subtle'>
      <Sidemenu pathname={pathname} />
      {header ? (
        <main className='min-w-0 flex grow flex-col overflow-y-auto background-primary'>
          {header}
          <div className='grow px-x4 pb-x4'>
            <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
          </div>
        </main>
      ) : (
        <main className='min-w-0 grow overflow-y-auto background-primary'>
          <div className='p-x4'>
            <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
          </div>
        </main>
      )}
    </div>
  );
};
